const ACCESS_KEY = "pma_access_token";
const REFRESH_KEY = "pma_refresh_token";
const USER_KEY = "pma_user";

let sessionActive = false;

export function getAccessToken() {
  return localStorage.getItem(ACCESS_KEY);
}

export function getRefreshToken() {
  return localStorage.getItem(REFRESH_KEY);
}

export function getStoredUser() {
  const raw = localStorage.getItem(USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function saveSession({ accessToken, refreshToken, user }) {
  if (accessToken) localStorage.setItem(ACCESS_KEY, accessToken);
  if (refreshToken) localStorage.setItem(REFRESH_KEY, refreshToken);
  if (user) localStorage.setItem(USER_KEY, JSON.stringify(user));
  sessionActive = Boolean(accessToken && user?.isActive !== false);
}

export function updateAccessToken(accessToken) {
  if (accessToken) localStorage.setItem(ACCESS_KEY, accessToken);
}

export function clearSession() {
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(REFRESH_KEY);
  localStorage.removeItem(USER_KEY);
  sessionActive = false;
}

export function setSessionActive(active) {
  sessionActive = active;
}

export function isSessionActive() {
  const token = getAccessToken();
  const user = getStoredUser();
  return Boolean(token && user?.isActive !== false);
}

export function hasStoredCredentials() {
  return Boolean(getAccessToken());
}
